import Checkbox from './checkbox';
import CompletedCheckbox from './completedCheckbox';

Checkbox.CompletedCheckbox = CompletedCheckbox;

export default Checkbox;
